import { useSigmaDashboard } from '@trinity/chat-components/hooks/useDashboard';

type SigmaIframeProps = {
  iframeUrl: string | null;
  /** CSS height of the frame. */
  height?: string | number;
};

/** A Sigma embed from a signed URL. No provider or context needed, so pages and apps can both use it. */
export const SigmaIframe = ({ iframeUrl, height = 600 }: SigmaIframeProps) => {
  if (!iframeUrl) return null;

  return (
    <iframe
      src={iframeUrl}
      title="Sigma Dashboard"
      width="100%"
      height={height}
      style={{ border: 0 }}
      allowFullScreen
    />
  );
};

type Props = {
  iframeUrl: string | null;
};

/** The Sigma dashboard of the surrounding project or brand. Renders nothing until its warehouse and schema are set. */
export const SigmaDashboard = ({ iframeUrl }: Props) => {
  const sigmaDashboard = useSigmaDashboard();

  if (!sigmaDashboard.warehouse || !sigmaDashboard.schema) {
    return null;
  }

  return <SigmaIframe iframeUrl={iframeUrl} />;
};
